export const themes = {
    "1": {
        id: 1,
        label: 'Theme 1',
        primary: "#386641",
        secondary: "#A7C957",
        appBg: "#F1F6F9",
        button: "#38664126",
        cardBg: "#ffffff",
        textDark: "#000",
        textLight: "#ffffff",
        listHoverBg: "#F1F6F9"
    },
    "2": {
        id: 2,
        label: 'Theme 2',
        primary: "#004E89",
        secondary: "#6AA2C9",
        appBg: "#F1F6F9",
        button: "#004E8926",
        cardBg: "#ffffff",
        textDark: "#000",
        textLight: "#ffffff",
        listHoverBg: "#F1F6F9"
    },
    "3": {
        id: 3,
        label: 'Theme 3 (Default)',
        primary: "#4C0055",
        secondary: "#FC5F3A",
        appBg: "#F1F6F9",
        button: "#4C005526",
        cardBg: "#ffffff",
        textDark: "#000",
        textLight: "#ffffff",
        listHoverBg: "#F1F6F9"
    },
    // "4": {
    //     id: 4,
    //     label: 'Theme 4 (Dark)',
    //     primary: "#007A7A",
    //     secondary: "#41A5A5",
    //     appBg: "#000000",
    //     button: "#007A7A26",
    //     cardBg: "#41A5A533",
    //     textDark: "#000",
    //     textLight: "#ffffff",
    //     listHoverBg: "#000000"
    // },
    "100": {
        id: 100,
        label: 'Custom Theme',
        primary: "#4C0055",
        secondary: "#FC5F3A",
        appBg: "#F1F6F9",
        button: "#D8D1E1",
        cardBg: "#ffffff",
        textDark: "#000",
        textLight: "#ffffff",
        listHoverBg: "#F1F6F9"
    },
};